/**
 * Thrown by the validating constructors in this package. Messages name the rule that failed and
 * never include the rejected value, because values may be idempotency keys or other evidence.
 */
export class DomainValidationError extends Error {
    field;
    constructor(field, rule) {
        super(`${field} ${rule}`);
        this.name = "DomainValidationError";
        this.field = field;
    }
}
const VISIBLE_ASCII = /^[\x21-\x7e]+$/;
export function correlationId(value) {
    if (typeof value !== "string" || value.length < 1 || value.length > 128) {
        throw new DomainValidationError("correlationId", "must be 1 to 128 characters");
    }
    return value;
}
export function idempotencyKey(value) {
    if (typeof value !== "string" || value.length > 255 || !VISIBLE_ASCII.test(value)) {
        throw new DomainValidationError("idempotencyKey", "must be 1 to 255 visible ASCII characters");
    }
    return value;
}
const UUID_SHAPE = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
/** Validates the uuid shape and returns the lowercase canonical text PostgreSQL prints and locks on. */
export function authSubjectId(value) {
    if (typeof value !== "string" || !UUID_SHAPE.test(value)) {
        throw new DomainValidationError("authSubjectId", "must be a canonical uuid");
    }
    return value.toLowerCase();
}
